
import { reactive, computed } from "vue";

function sum(arr, end = arr.length - 1) {
  let sum = 0;
  for (let i = 0; i <= end; i++) {
    sum += arr[i];
  }
  return sum;
}


export function getData() {
  // 0定义基本参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let power = reactive({
    name: "power",
    title: "单台风机MW数",
    value: 0.0,
  });
  let hub_Height = reactive({
    name: "hub_Height",
    title: "轮毂高度(m)",
    value: 0.0,
  });
  let seism = reactive({
    name: "seism",
    title: "地震设防烈度",
    value: 0,
  });
  let weight = reactive({
    name: "weight",
    title: "塔架+顶部重量(t)",
    value: 0.0,
  });

  let params_basic = [
    power,
    hub_Height,
    seism,
    weight,
  ]

  // 1定义几何参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let R = reactive({
    name: "R",
    title: "底板半径R",
    value: 10,
    disabled: false,
  });
  let R1 = reactive({
    name: "R1",
    title: "棱台顶面半径R1",
    value: 3.4,
    disabled: false,
  });
  let R2 = reactive({
    name: "R2",
    title: "台柱半径R2",
    value: computed(() => R1.value),
    disabled: true,
  });
  let H1 = reactive({
    name: "H1",
    title: "底板外缘高度H1",
    value: 0.9,
    disabled: false,
  });
  let H2 = reactive({
    name: "H2",
    title: "底板棱台高度H2",
    value: 1.9,
    disabled: false,
  });
  let H3 = reactive({
    name: "H3",
    title: "台柱高度H3",
    value: 1.5,
    disabled: false,
  });
  let Hd = reactive({
    name: "Hd",
    title: "基础埋深hb",
    value: 4.1,
    disabled: false,
  });
  let Hb = reactive({
    name: "Hb",
    title: "荷载标高Hf",
    value: 0.3,
    disabled: false,
  });
  let T_set = reactive({ name: "T_set", title: "是否设置塔梯支墩", value: 1 });
  let TL = reactive({
    name: "TL",
    title: "塔梯支墩长(x向)",
    value: 1.5,
    disabled: false,
  });
  let TW = reactive({
    name: "TW",
    title: "塔梯支墩宽(y向)",
    value: 0.4,
    disabled: false,
  });
  let TH = reactive({
    name: "TH",
    title: "塔梯支墩高",
    value: 0.6,
    disabled: false,
  });
  let Tdist = reactive({
    name: "Tdist",
    title: "支墩距中心距离",
    value: 5.8,
    disabled: false,
  });
  let P_set = reactive({ name: "P_set", title: "是否设置散热平台", value: 1 });
  let PW = reactive({
    name: "PW",
    title: "散热器平台宽",
    value: 1.8,
    disabled: false,
  });
  let Pdist = reactive({
    name: "Pdist",
    title: "平台边至中心距离",
    value: 4.5,
    disabled: false,
  });
  let PT_angle1 = reactive({
    name: "angle1",
    title: "平台布置角度1",
    value: 45,
    disabled: false,
  });
  let PT_angle2 = reactive({
    name: "angle2",
    title: "平台布置角度2",
    value: "无",
    disabled: false,
  });
  let PT_bar_h = reactive({
    name: "bar_h",
    title: "平台水平筋d(mm)",
    value: 12,
    disabled: false,
  });
  let PT_bar_v = reactive({
    name: "bar_v",
    title: "平台竖向筋d(mm)",
    value: 16,
    disabled: false,
  });
  let DD = reactive({
    name: "DD",
    title: "排水管直径(mm)",
    value: 50,
    disabled: false,
  });
  let R_observe = reactive({
    name: "R_observe",
    title: "沉降观测点半径",
    value: 3.2,
    disabled: false,
  });
  let Ratio = reactive({
    name: "Ratio",
    title: "基坑坡比1：",
    value: 0.5,
    disabled: false,
  });
  let holeDepth = reactive({
    name: "holeDepth",
    title: "锚栓凹槽深度",
    value: 0.3,
    disabled: false,
  });
  let holeRadius = reactive({
    name: "holeRadius",
    title: "锚栓凹槽半径",
    value: 2.9,
    disabled: false,
  });
  let holeCushionThick = reactive({
    name: "holeCushionThick",
    title: "凹槽垫层厚度",
    value: 0.2,
    disabled: false,
  });
  let cushionThick = reactive({
    name: "cushionThick",
    title: "基础垫层厚度",
    value: 0.1,
    disabled: false,
  });
  let extralWidth = reactive({
    name: "extralWidth",
    title: "基坑肥槽宽度",
    value: 0.5,
    disabled: false,
  });
  let backFillRatio = reactive({
    name: "backFillRatio",
    title: "回填土坡比(％)",
    value: 1,
    disabled: false,
    // 相对于台柱顶面中点的X坐标：单位毫米
    slopX: computed(() => (R.value * 1000 + 100 + extralWidth.value * 1000) +
      (
        (Hd.value * 1000 + cushionThick.value * 1000) -
        backFillRatio.value / 100 * (R.value * 1000 - R2.value * 1000 + 100 + extralWidth.value * 1000)
      )
      / (1 / Ratio.value + backFillRatio.value / 100)
    ),
    // 相对于台柱顶面中点的Y坐标：单位毫米
    slopY: computed(() => (H1.value + H2.value + H3.value) * 1000 - Hd.value * 1000 + backFillRatio.value / 100 * (backFillRatio.slopX - R2.value * 1000)),
    // 基础范围内覆土体积：单位立方米
    vol: computed(() => {
      let h = (R.value - R2.value) * backFillRatio.value
      let v1 = (Hd.value - h) * Math.PI * Math.pow(R.value, 2) + h / 3 * (
        Math.PI * Math.pow(R.value, 2) + Math.PI * Math.pow(R2.value, 2) + Math.PI * R.value * R2.value
      )
      let v2 = Math.PI * Math.pow(R.value, 2) * H1.value +
        ((H2.value) / 3) *
        (Math.PI * Math.pow(R.value, 2) +
          Math.PI * Math.pow(R1.value, 2) +
          Math.PI * R.value * R1.value) +
        (Hd.value - (H2.value + H1.value)) * Math.PI * Math.pow(R2.value, 2)
      return (v1 - v2).toFixed(2)
    })
  });

  let params_geometry = [
    R,
    R1,
    R2,
    H1,
    H2,
    H3,
    Hd,
    Hb,
    T_set,
    TL,
    TW,
    TH,
    Tdist,
    P_set,
    PW,
    Pdist,
    PT_angle1,
    PT_angle2,
    PT_bar_h,
    PT_bar_v,
    DD,
    R_observe,
    Ratio,
    holeDepth,
    holeRadius,
    holeCushionThick,
    cushionThick,
    extralWidth,
    backFillRatio,
  ];

  // 2定义锚栓参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let Bnum_in = reactive({
    name: "Bnum_in",
    title: "内锚栓根数",
    value: 104,
  });
  let Bd_in = reactive({
    name: "Bd_in",
    title: "内锚栓直径",
    value: 48,
  });
  let Br_in = reactive({
    name: "Br_in",
    title: "内锚栓定位半径",
    value: 2300,
  });
  let BPlate_in = reactive({
    name: "BPlate_in",
    title: "上锚板内半径",
    value: 2100,
  });
  let BAnchor_in = reactive({
    name: "BAnchor_in",
    title: "下锚板内半径",
    value: 2150,
  });
  let Bnum_out = reactive({
    name: "Bnum_out",
    title: "外锚栓根数",
    value: computed(() => Bnum_in.value),
    status: true,
  });
  let Bd_out = reactive({
    name: "Bd_out",
    title: "外锚栓直径",
    value: computed(() => Bd_in.value),
    status: true,
  });
  let Br_out = reactive({
    name: "Br_out",
    title: "外锚栓定位半径",
    value: 2500,
  });
  let BPlate_out = reactive({
    name: "BPlate_out",
    title: "上锚板外半径",
    value: 2700,
  });
  let BAnchor_out = reactive({
    name: "BAnchor_out",
    title: "下锚板外半径",
    value: 2650,
  });
  let hole = reactive({
    name: "hole",
    title: "锚板开孔直径",
    value: 42,
  });
  let BBrace_num = reactive({
    name: "BBrace_num",
    title: "锚栓支撑M1个数",
    value: 10,
  });
  let BBrace_width = reactive({
    name: "BBrace_width",
    title: "M1尺寸(环向)",
    value: 400,
  });
  let BBrace_length = reactive({
    name: "BBrace_length",
    title: "M1尺寸(径向)",
    value: 400,
  });
  let BBrace_t = reactive({
    name: "BBrace_t",
    title: "M1厚度",
    value: 20,
  });
  let BBrace_bar = reactive({
    name: "BBrace_bar",
    title: "M1锚筋直径",
    value: 16,
  });
  let Grout_thick = reactive({
    name: "Grout_thick",
    title: "高强灌浆料厚度",
    value: 80,
  });
  let Grout_extension = reactive({
    name: "Grout_extension",
    title: "高强灌浆料外扩",
    value: 80,
  });
  let Grout_strength = reactive({
    name: "Grout_strength",
    title: "灌浆料受压强度(MPa)",
    value: 120,
  });
  let bolt_fu = reactive({
    name: "bolt_fu",
    title: "锚栓抗拉强度(MPa)",
    value: 1040,
  });
  let bolt_fy = reactive({
    name: "bolt_fy",
    title: "锚栓屈服强度(MPa)",
    value: 940,
  });
  let bolt_area = reactive({
    name: "bolt_area",
    title: "锚栓面积(mm2)",
    value: 976,
  });
  let bolt_preforce = reactive({
    name: "bolt_preforce",
    title: "锚栓预拉力(kN)",
    value: 520,
  });
  let params_bolt = [
    Bnum_in,
    Bd_in,
    Bnum_out,
    Bd_out,
    Br_in,
    Br_out,
    BPlate_in,
    BPlate_out,
    BAnchor_in,
    BAnchor_out,
    hole,
    BBrace_num,
    BBrace_width,
    BBrace_length,
    BBrace_t,
    BBrace_bar,
    Grout_thick,
    Grout_extension,
    Grout_strength,
    bolt_fu,
    bolt_fy,
    bolt_area,
    bolt_preforce,


  ];

  // 3定义埋件参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let M2_set = reactive({
    name: "M2_set",
    title: "是否设塔底埋件M2",
    value: 1,
  });
  let M2_W = reactive({
    name: "M2_W",
    title: "M2尺寸(x向)",
    value: 300,
    disabled: false,
  });
  let M2_L = reactive({
    name: "M2_L",
    title: "M2尺寸(y向)",
    value: 300,
    disabled: false,
  });
  let M2_t = reactive({
    name: "M2_t",
    title: "M2厚度",
    value: 20,
    disabled: false,
  });
  let M2_bar = reactive({
    name: "M2_bar",
    title: "M2锚筋直径",
    value: 16,
    disabled: false,
  });
  let M2_distX = reactive({
    name: "M2_distX",
    title: "M2间距(x向)",
    value: 1800,
    disabled: false,
  });
  let M2_distY = reactive({
    name: "M2_distY",
    title: "M2间距(y向)",
    value: 1200,
    disabled: false,
  });
  let M3_set = reactive({
    name: "M3_set",
    title: "是否设塔梯埋件M3",
    value: 1,
  });
  let M3_W = reactive({
    name: "M3_W",
    title: "M3尺寸(x向)",
    value: 250,
    disabled: false,
  });
  let M3_L = reactive({
    name: "M3_L",
    title: "M3尺寸(y向)",
    value: 250,
    disabled: false,
  });
  let M3_t = reactive({
    name: "M3_t",
    title: "M3厚度",
    value: 20,
    disabled: false,
  });
  let M3_bar = reactive({
    name: "M3_bar",
    title: "M3锚筋直径",
    value: 16,
    disabled: false,
  });
  let M3_distX = reactive({
    name: "M3_distX",
    title: "M3间距(x向)",
    value: TL.value * 1000 - 900,
    disabled: false,
  });
  let M4_set = reactive({
    name: "M4_set",
    title: "是否设平台埋件M4",
    value: 1,
  });
  let M4_L = reactive({
    name: "M4_L",
    title: "M4长度(环向)",
    value: 1500,
    disabled: false,
  });
  let M4_L_W = reactive({
    name: "M4_L_W",
    title: "横截面宽度(径向)",
    value: 100,
    disabled: false,
  });
  let M4_W = reactive({
    name: "M4_W",
    title: "M4宽度(径向)",
    value: 600,
    disabled: false,
  });
  let M4_W_W = reactive({
    name: "M4_W_W",
    title: "横截面宽度(环向)",
    value: 100,
    disabled: true,
  });
  let M4_t = reactive({
    name: "M4_t",
    title: "M4厚度",
    value: 20,
    disabled: false,
  });
  let M4_bar = reactive({
    name: "M4_bar",
    title: "M4锚筋直径",
    value: 16,
    disabled: false,
  });
  let M4_distR = reactive({
    name: "M4_distR",
    title: "M4边距(径向)",
    value: 300,
    disabled: false,
  });

  let params_embed = [
    M2_set,
    M2_W,
    M2_L,
    M2_t,
    M2_bar,
    M2_distX,
    M2_distY,
    M3_set,
    M3_W,
    M3_L,
    M3_t,
    M3_bar,
    M3_distX,
    M4_set,
    M4_L,
    M4_L_W,
    M4_W,
    M4_W_W,
    M4_t,
    M4_bar,
    M4_distR,
  ];

  // 4定义保护层参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let cover_btm = reactive({
    name: "cover_btm",
    title: "保护层厚度: 底部",
    value: 80,
    imgShow: false,
  });
  let cover_other = reactive({
    name: "cover_other",
    title: "其它",
    value: 50,
    imgShow: false,
  });

  let cover = [cover_btm, cover_other];

  // 5定义配筋参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>status: true为只读
  let bar_1 = reactive({
    No: "01",
    diameter: { name: "1_diameter", value: 32 },
    space: { name: "1_space", value: "—", status: true },
    num: { name: "1_num", value: computed(() => Bnum_in.value), status: true },
    data: {
      data_a: { name: "data_1_a", title: "参数a", value: 600 },
      data_b: { name: "data_1_b", title: "参数b", value: 8150 },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/01.png",
    singleLength: computed(() => bar_1.data.data_a.value + bar_1.data.data_b.value),
    length: computed(
      () =>
        Math.round(
          ((bar_1.singleLength) *
            bar_1.num.value) /
          10
        ) / 100
    ),
  });

  let bar_1a = reactive({
    No: "01a",
    diameter: { name: "1a_diameter", value: 28 },
    space: { name: "1a_space", value: "—", status: true },
    data: {
      data_n: { name: "data_1a_n", title: "根数为01的n倍", value: 1 },
      data_a: { name: "data_1a_a", title: "参数a", value: 600 },
      data_b: { name: "data_1a_b", title: "参数b", value: 7500 },
      data_c: { name: "data_1a_c", title: "参数c", value: 400 },
    },
    num: {
      name: "data_1a_num",
      value: computed(() => {
        if (bar_1a.data.data_n.value == '') {
          return Bnum_in.value
        } else {
          return Math.floor(Math.max(Bnum_in.value * bar_1a.data.data_n.value, 1))
        }
      }
      ),
      status: true
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/01a.png",
    singleLength: computed(() => bar_1a.data.data_a.value + bar_1a.data.data_b.value + bar_1a.data.data_c.value),
    length: computed(
      () =>
        Math.round(
          ((bar_1a.singleLength) *
            bar_1a.num.value) /
          10
        ) / 100
    ),
  });

  let bar_1b = reactive({
    No: "01b",
    diameter: { name: "1b_diameter", value: 25, status: true },
    space: { name: "1b_space", value: "—", status: true },
    num: {
      name: "1b_num",
      value: computed(() => {
        if (bar_1b.data.data_set.value == 0) {
          return 0
        } else {
          return Bnum_in.value
        }
      }),
      status: true
    },
    data: {
      data_set: { name: "data_1b_set", title: "是否设置", value: 0 },
      data_a: { name: "data_1b_a", title: "参数a", value: 0, status: true },
      data_b: { name: "data_1b_b", title: "参数b", value: 0, status: true },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/01.png",
    singleLength: computed(() => bar_1b.data.data_a.value + bar_1b.data.data_b.value),
    length: computed(
      () =>
        Math.round(
          ((bar_1b.singleLength) *
            bar_1b.num.value) /
          10
        ) / 100

    ),
  });

  let bar_1c = reactive({
    No: "01c",
    diameter: { name: "1c_diameter", value: 20, status: true },
    space: { name: "1c_space", value: 200, status: true },
    num: { name: "1c_num", value: 0, status: true },
    data: {

      data_a: {
        name: "data_1c_a",
        title: "半径R1",
        value: 0,
        status: true,
      },
      data_b: {
        name: "data_1c_b",
        title: "半径R2",
        value: 0,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/05.png",
    singleLength: computed(() =>
      [
        Math.round(bar_1c.data.data_a.value * Math.PI * 2),
        Math.round(bar_1c.data.data_b.value * Math.PI * 2),
      ]
    ),
    length: computed(() => {
      return (
        Math.round(
          ((sum(bar_1c.singleLength) / 2) /
            10) *
          bar_1c.num.value
        ) / 100
      );
    }),
  });

  let bar_2 = reactive({
    No: "02",
    diameter: { name: "2_diameter", value: 28 },
    space: { name: "2_space", value: "—", status: true },
    num: { name: "2_num", value: computed(() => Bnum_in.value), status: true },
    data: {
      data_a: { name: "data_2_a", title: "参数a", value: 600 },
      data_b: { name: "data_2_b", title: "参数b", value: 6850 },
      data_c: { name: "data_2_c", title: "参数c", value: 1400 },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/02.png",
    singleLength: computed(() => bar_2.data.data_a.value + bar_2.data.data_b.value + bar_2.data.data_c.value),
    length: computed(
      () =>
        Math.round(
          ((bar_2.singleLength) *
            bar_2.num.value) /
          10
        ) / 100
    ),

  });

  let bar_2a = reactive({
    No: "02a",
    diameter: { name: "2a_diameter", value: 28 },
    space: { name: "2a_space", value: "—", status: true },
    num: {
      name: "2a_num",
      value: computed(() => {
        if (bar_2a.data.data_n.value == '') {
          return Bnum_in.value
        } else {
          return Math.floor(Math.max(Bnum_in.value * bar_2a.data.data_n.value, 1))
        }
      }),
      status: true
    },
    data: {
      data_n: { name: "data_2a_n", title: "根数为02的n倍", value: 1 },
      data_a: { name: "data_2a_a", title: "参数a", value: 600 },
      data_b: { name: "data_2a_b", title: "参数b", value: 6850, status: true },
      data_c: { name: "data_2a_c", title: "参数c", value: 1000 },
      data_d: { name: "data_2a_d", title: "参数d", value: 350 },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/02a.png",
    singleLength: computed(() => bar_2a.data.data_a.value + bar_2a.data.data_b.value + bar_2a.data.data_c.value + bar_2a.data.data_d.value),
    length: computed(
      () =>
        Math.round(
          ((bar_2a.singleLength) *
            bar_2a.num.value) /
          10
        ) / 100
    ),
  });

  let bar_3 = reactive({
    No: "03",
    diameter: { name: "3_diameter", value: 12 },
    space: { name: "3_space", value: "—", status: true },
    num: { name: "3_num", value: 4, status: false },
    data: {
      data_a: {
        name: "data_3_a",
        title: "半径R",
        value: R.value * 1000 - 50 - 12 / 2,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/03&12~13.png",
    singleLength: computed(() => Math.round(bar_3.data.data_a.value * Math.PI * 2)),
    length: computed(
      () =>
        Math.round(
          (bar_3.singleLength * bar_3.num.value) / 10
        ) / 100
    ),
  });



  function get_section_data_a(bar, insert_r) {
    let temp_a = insert_r
    if (insert_r == 0) {
      temp_a = R.value * 1000 - cover_other.value - bar_3.diameter.value - bar_1.diameter.value - 15;
    }
    return bar.data.data_b.value + bar.space.value * Math.floor(
      (temp_a - bar.data.data_b.value) / bar.space.value
    );
  }

  let bar_4 = reactive({
    No: "04",
    diameter: { name: "4_diameter", value: 25 },
    space: { name: "4_space", value: 100, status: false },
    num: {
      name: "4_num",
      value: computed(() => bar_4.data.data_e.value + (bar_4.data.data_a.value - bar_4.data.data_b.value) / bar_4.space.value + 1),
      status: true
    },
    data: {
      data_set: {
        name: "segments",
        title: " 分段数",
        value: 1,
        status: false,
      },
      data_r1: {
        name: "s_r1",
        title: "内分段半径",
        value: '_',
        status: true,
      },
      data_r2: {
        name: "s_r2",
        title: "外分段半径",
        value: '_',
        status: true,
      },
      data_a: {
        name: "data_4_a",
        title: "半径R1",
        value: computed(() => {
          if (bar_4.data.data_set.value == 1) {
            return get_section_data_a(bar_4, 0);
          } else {
            return bar_4.data.data_b.value + bar_4.space.value * Math.floor(
              (bar_4.data.data_r1.value - bar_4.data.data_b.value) / bar_4.space.value
            );
          }
        }),
        status: true,
      },
      data_b: {
        name: "data_4_b",
        title: "半径R2",
        value: computed(() => Br_out.value + 100),
        status: true,
      },
      data_c: {
        name: "data_4_c",
        title: "半径R3",
        value: computed(() => Br_in.value - 100),
        status: true,
      },
      data_d: {
        name: "data_4_d",
        title: "半径R4",
        value: computed(() => Br_in.value - 100 - bar_4.space.value * (bar_4.data.data_e.value - 1)),
        status: true,
      },
      data_e: {
        name: "data_4_e",
        title: "锚栓内根数",
        value: 3,
        status: false,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/04&14.png",
    singleLength: computed(() =>
      [
        Math.round(bar_4.data.data_a.value * Math.PI * 2),
        Math.round(bar_4.data.data_b.value * Math.PI * 2),
        Math.round(bar_4.data.data_c.value * Math.PI * 2),
        Math.round(bar_4.data.data_d.value * Math.PI * 2),
      ]),
    length: computed(() => {
      return (
        Math.round(
          (((bar_4.singleLength[0] + bar_4.singleLength[1]) / 2) /
            10) *
          (bar_4.num.value - bar_4.data.data_e.value) +
          (((bar_4.singleLength[2] + bar_4.singleLength[3]) / 2) /
            10) *
          bar_4.data.data_e.value
        ) / 100
      );
    }),
  });

  // 4的分段参数↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  let bar_4a = reactive({
    No: "04a",
    diameter: { name: "4a_diameter", value: computed(() => bar_4.diameter.value), status: true },
    space: { name: "4a_space", value: 150, status: false },
    num: {
      name: "4a_num",
      value: computed(() => {
        if (bar_4.data.data_set.value >= 2) {
          return (bar_4a.data.data_a.value - bar_4a.data.data_b.value) / bar_4a.space.value + 1
        } else {
          return 0
        }
      }),
      status: true
    },
    data: {
      data_a: {
        name: "data_4a_a",
        title: "半径R1",
        value: computed(() => {
          if (bar_4.data.data_set.value == 1) {
            return '_'
          } else if (bar_4.data.data_set.value == 2) {
            let end_r = R.value * 1000 - cover_other.value - bar_3.diameter.value - bar_1.diameter.value - 15;
            return bar_4a.data.data_b.value + bar_4a.space.value * Math.floor(
              (end_r - bar_4a.data.data_b.value) / bar_4a.space.value
            );
          } else {
            return bar_4a.data.data_b.value + bar_4a.space.value * Math.floor(
              (bar_4.data.data_r2.value - bar_4a.data.data_b.value) / bar_4a.space.value
            );
          }
        }),
        status: true,
      },
      data_b: {
        name: "data_4a_b",
        title: "半径R2",
        value: computed(() => {
          if (bar_4.data.data_set.value == 1) {
            return '_'
          } else {
            return bar_4.data.data_a.value + bar_4a.space.value
          }
        }),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/05.png",
    singleLength: computed(() => {
      if (bar_4a.num.value == 0) {
        return [0, 0]
      } else {
        return [
          Math.round(bar_4a.data.data_a.value * Math.PI * 2),
          Math.round(bar_4a.data.data_b.value * Math.PI * 2),
        ]
      }
    }

    ),
    length: computed(() => {
      if (bar_4a.num.value == 0) {
        return 0
      } else {
        return (
          Math.round(
            ((sum(bar_4a.singleLength) / 2) /
              10) *
            bar_4a.num.value
          ) / 100
        );
      }
    }),
  });

  let bar_4b = reactive({
    No: "04b",
    diameter: { name: "4b_diameter", value: computed(() => bar_4.diameter.value), status: true },
    space: { name: "4b_space", value: 200, status: false },
    num: {
      name: "4b_num",
      value: computed(() => {
        if (bar_4.data.data_set.value >= 3) {
          return (bar_4b.data.data_a.value - bar_4b.data.data_b.value) / bar_4b.space.value + 1
        } else {
          return 0
        }
      }),
      status: true
    },
    data: {
      data_a: {
        name: "data_4b_a",
        title: "半径R1",
        value: computed(() => {
          if (bar_4.data.data_set.value < 2) {
            return '_'
          } else {
            return get_section_data_a(bar_4b, 0)
          }
        }),
        status: true,
      },
      data_b: {
        name: "data_4b_b",
        title: "半径R2",
        value: computed(() => {
          if (bar_4.data.data_set.value < 2) {
            return '_'
          } else {
            return bar_4a.data.data_a.value + bar_4b.space.value
          }
        }),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/05.png",
    singleLength: computed(() => {
      if (bar_4b.num.value == 0) {
        return [0, 0]
      } else {
        return [
          Math.round(bar_4b.data.data_a.value * Math.PI * 2),
          Math.round(bar_4b.data.data_b.value * Math.PI * 2),
        ]
      }
    }),
    length: computed(() => {
      if (bar_4b.num.value == 0) {
        return 0
      } else {
        return (
          Math.round(
            ((sum(bar_4b.singleLength) / 2) /
              10) *
            bar_4b.num.value
          ) / 100
        );
      }

    }),
  });
  // 4的分段参数↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑






  let bar_5 = reactive({
    No: "05",
    diameter: { name: "5_diameter", value: 25 },
    space: { name: "5_space", value: computed(() => bar_4.space.value), status: true },
    num: {
      name: "5_num",
      value: computed(() => (bar_5.data.data_a.value - bar_5.data.data_b.value) / bar_5.space.value + 1),
      status: true
    },
    data: {
      data_a: {
        name: "data_5_a",
        title: "半径R1",
        value: computed(() => bar_4.data.data_a.value),
        status: true,
      },
      data_b: {
        name: "data_5_b",
        title: "半径R2",
        value: computed(() => {
          return bar_5.data.data_a.value - bar_5.space.value * Math.floor(
            (bar_5.data.data_a.value - R1.value * 1000) / bar_5.space.value
          )
        }),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/05.png",
    singleLength: computed(() =>
      [
        Math.round(bar_5.data.data_a.value * Math.PI * 2),
        Math.round(bar_5.data.data_b.value * Math.PI * 2),
      ]
    ),
    length: computed(() => {
      return (
        Math.round(
          ((sum(bar_5.singleLength) / 2) /
            10) *
          bar_5.num.value
        ) / 100
      );
    }),
  });


  // 5的分段参数↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  let bar_5a = reactive({
    No: "05a",
    diameter: { name: "5a_diameter", value: computed(() => bar_5.diameter.value), status: true },
    space: { name: "5a_space", value: computed(() => bar_4a.space.value), status: true },
    num: {
      name: "5a_num",
      value: computed(() => {
        if (bar_4.data.data_set.value >= 2) {
          return (bar_5a.data.data_a.value - bar_5a.data.data_b.value) / bar_5a.space.value + 1
        } else {
          return 0
        }
      }),
      status: true
    },
    data: {
      data_a: {
        name: "data_5a_a",
        title: "半径R1",
        value: computed(() => bar_4a.data.data_a.value),
        status: true,
      },
      data_b: {
        name: "data_5a_b",
        title: "半径R2",
        value: computed(() => bar_4a.data.data_b.value),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/05.png",
    singleLength: computed(() => {
      if (bar_5a.num.value == 0) {
        return [0, 0]
      } else {
        return [
          Math.round(bar_5a.data.data_a.value * Math.PI * 2),
          Math.round(bar_5a.data.data_b.value * Math.PI * 2),
        ]
      }
    }),
    length: computed(() => {
      if (bar_5a.num.value == 0) {
        return 0
      } else {
        return (
          Math.round(
            ((sum(bar_5a.singleLength) / 2) /
              10) *
            bar_5a.num.value
          ) / 100
        );
      }
    }),
  });

  let bar_5b = reactive({
    No: "05b",
    diameter: { name: "5b_diameter", value: computed(() => bar_5.diameter.value), status: true },
    space: { name: "5b_space", value: computed(() => bar_4b.space.value), status: true },
    num: {
      name: "5b_num",
      value: computed(() => {
        if (bar_4.data.data_set.value >= 3) {
          return (bar_5b.data.data_a.value - bar_5b.data.data_b.value) / bar_5b.space.value + 1
        } else {
          return 0
        }
      }),
      status: true
    },
    data: {
      data_a: {
        name: "data_5b_a",
        title: "半径R1",
        value: computed(() => bar_4b.data.data_a.value),
        status: true,
      },
      data_b: {
        name: "data_5b_b",
        title: "半径R2",
        value: computed(() => bar_4b.data.data_b.value),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/05.png",
    singleLength: computed(() => {
      if (bar_5b.num.value == 0) {
        return [0, 0]
      } else {
        return [
          Math.round(bar_5b.data.data_a.value * Math.PI * 2),
          Math.round(bar_5b.data.data_b.value * Math.PI * 2),
        ]
      }
    }),
    length: computed(() => {
      if (bar_5b.num.value == 0) {
        return 0
      } else {
        return (
          Math.round(
            ((sum(bar_5b.singleLength) / 2) /
              10) *
            bar_5b.num.value
          ) / 100
        );
      }
    }),
  });
  // 5的分段参数↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑


  let bar_6 = reactive({
    No: "06",
    diameter: { name: "6_diameter", value: 20 },
    space: { name: "6_space", value: 200, status: false },
    num: { name: "6_num", value: 42, status: true },
    data: {
      data_a: {
        name: "data_6_a",
        title: "参数a",
        value: 4100,
        status: false,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/06.png",
    singleLength: computed(() => bar_6.data.data_a.value),
    length: computed(() => Math.round((bar_6.data.data_a.value * bar_6.num.value) / 10) / 100
    ),
  });

  let bar_7 = reactive({
    No: "07",
    diameter: { name: "7_diameter", value: 20 },
    space: { name: "7_space", value: 200, status: false },
    num: { name: "7_num", value: 26, status: true },
    data: {
      data_a: {
        name: "data_7_a",
        title: "直径D",
        value: 3900,
        status: false,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/07~07a.png",
    singleLength: computed(() => {
      let L = bar_7.data.data_a.value;
      for (let i = 1; i <= (bar_7.num.value / 2 - 1) / 2; i++) {
        L +=
          2 *
          2 *
          Math.sqrt(
            Math.pow(bar_7.data.data_a.value / 2, 2) -
            Math.pow(bar_7.space.value * i, 2)
          );
      }
      return Math.round(parseInt(2 * L));
    }),
    length: computed(() => Math.round(bar_7.singleLength / 10) / 100)
  });

  let bar_7a = reactive({
    No: "07a",
    diameter: { name: "7a_diameter", value: 12 },
    space: { name: "7a_space", value: 200, status: false },
    num: { name: "7a_num", value: 78, status: true },
    data: {
      data_a: {
        name: "data_7a_a",
        title: "直径D",
        value: 3800,
        status: false,
      },
      data_b: {
        name: "data_7a_b",
        title: "层数",
        value: 3,
        status: false,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/07~07a.png",
    singleLength: computed(() => {
      let L = bar_7a.data.data_a.value;
      for (
        let i = 1;
        i <= (bar_7a.num.value / bar_7a.data.data_b.value / 2 - 1) / 2;
        i++
      ) {
        L +=
          2 *
          2 *
          Math.sqrt(
            Math.pow(bar_7a.data.data_a.value / 2, 2) -
            Math.pow(bar_7a.space.value * i, 2)
          );
      }
      return Math.round(parseInt((2 * L)));
    }),
    length: computed(() => Math.round(bar_7a.singleLength * bar_7a.data.data_b.value / 10) / 100)
  });

  let bar_8 = reactive({
    No: "08",
    diameter: { name: "8_diameter", value: 32 },
    space: { name: "8_space", value: "—", status: true },
    num: { name: "8_num", value: computed(() => Bnum_in.value), status: true },
    data: {
      data_a: {
        name: "data_8_a",
        title: "参数a",
        value: 4025,
        status: true,
      },
      data_b: {
        name: "data_8_b",
        title: "参数b",
        value: 1835,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/08.png",
    singleLength: computed(() => 2 * (bar_8.data.data_a.value + bar_8.data.data_b.value)),
    length: computed(
      () =>
        Math.round((bar_8.singleLength * bar_8.num.value) / 10) / 100
    ),
  });

  let bar_9 = reactive({
    No: "09",
    diameter: { name: "9_diameter", value: 16 },
    space: { name: "9_space", value: "—", status: true },
    num: {
      name: "9_num",
      value: Bnum_in.value * 6,
      status: true,
    },
    data: {
      data_a: {
        name: "data_9_a",
        title: "参数a",
        value: 1885,
        status: true,
      },
      data_b: {
        name: "data_9_b",
        title: "参数b",
        value: 175,
        status: true,
      },
      data_c: {
        name: "data_9_c",
        title: "层数",
        value: 6,
        status: false,
      },
      data_d: {
        name: "data_9_d",
        title: "层间距",
        value: 100,
        status: false,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/09~11.png",
    singleLength: computed(() => bar_9.data.data_a.value + 2 * bar_9.data.data_b.value),
    length: computed(
      () =>
        Math.round(
          ((bar_9.singleLength) *
            bar_9.num.value) /
          10) / 100
    ),
  });

  let bar_10 = reactive({
    No: "10",
    diameter: { name: "10_diameter", value: 16 },
    space: {
      name: "10_space",
      value: "—",
      status: true,
    },
    num: { name: "10_num", value: Bnum_in.value * 3, status: true },
    data: {
      data_a: {
        name: "data_10_a",
        title: "参数a",
        value: 1885,
        status: true,
      },
      data_b: {
        name: "data_10_b",
        title: "参数b",
        value: 175,
        status: true,
      },
      data_c: {
        name: "data_10_c",
        title: "层数",
        value: 3,
        status: false,
      },
      data_d: {
        name: "data_10_d",
        title: "层间距",
        value: computed(() => bar_9.data.data_d.value),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/09~11.png",
    singleLength: computed(() => bar_10.data.data_a.value + 2 * bar_10.data.data_b.value),
    length: computed(
      () =>
        Math.round(
          ((bar_10.singleLength) *
            bar_10.num.value) /
          10) / 100
    ),
  });

  let bar_11 = reactive({
    No: "11",
    diameter: { name: "11_diameter", value: 12 },
    space: {
      name: "11_space",
      value: "—",
      status: true,
    },
    num: {
      name: "11_num",
      value: Bnum_in.value * 15,
      status: true,
    },
    data: {
      data_a: {
        name: "data_11_a",
        title: "参数a",
        value: 1880,
        status: true,
      },
      data_b: {
        name: "data_11_b",
        title: "参数b",
        value: 130,
        status: true,
      },
      data_c: {
        name: "data_11_c",
        title: "层数",
        value: computed(() => {
          let num =
            (bar_8.data.data_a.value -
              bar_9.data.data_c.value * bar_9.data.data_d.value -
              bar_10.data.data_c.value * bar_10.data.data_d.value) %
            (2 * bar_9.data.data_d.value);
          if (num == 0) {
            return (
              (bar_8.data.data_a.value -
                bar_9.data.data_c.value * bar_9.data.data_d.value -
                bar_10.data.data_c.value * bar_10.data.data_d.value) /
              (2 * bar_9.data.data_d.value) -
              1
            );
          } else {
            return Math.floor(
              (bar_8.data.data_a.value -
                bar_9.data.data_c.value * bar_9.data.data_d.value -
                bar_10.data.data_c.value * bar_10.data.data_d.value) /
              (2 * bar_9.data.data_d.value)
            );
          }
        }),
        status: true,
      },
      data_d: {
        name: "data_11_d",
        title: "层间距",
        value: computed(() => bar_9.data.data_d.value * 2),
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/09~11.png",
    singleLength: computed(() => bar_11.data.data_a.value + 2 * bar_11.data.data_b.value),
    length: computed(
      () =>
        Math.round(
          ((bar_11.singleLength) *
            bar_11.num.value) /
          10) / 100
    ),
  });

  let bar_12 = reactive({
    No: "12",
    diameter: { name: "12_diameter", value: 16 },
    space: { name: "12_space", value: "—", status: true },
    num: {
      name: "12_num",
      value: computed(
        () =>
          bar_9.data.data_c.value +
          bar_10.data.data_c.value +
          bar_11.data.data_c.value
      ),
      status: true,
    },
    data: {
      data_a: {
        name: "data_12_a",
        title: "半径R",
        value: R2.value * 1000 - 50 - 16 / 2,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/03&12~13.png",
    singleLength: computed(() => Math.round(bar_12.data.data_a.value * Math.PI * 2)),
    length: computed(
      () => Math.round((bar_12.singleLength * bar_12.num.value) / 10) / 100
    ),
  });

  let bar_13 = reactive({
    No: "13",
    diameter: { name: "13_diameter", value: 16 },
    space: { name: "13_space", value: "—", status: true },
    num: {
      name: "13_num",
      value: computed(
        () =>
          bar_9.data.data_c.value +
          bar_10.data.data_c.value +
          bar_11.data.data_c.value
      ),
      status: true,
    },
    data: {
      data_a: {
        name: "data_13_a",
        title: "半径R",
        value:
          R2.value * 1000 -
          50 -
          bar_12.diameter.value -
          bar_8.data.data_b.value -
          bar_8.diameter.value -
          16 / 2,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/03&12~13.png",
    singleLength: computed(() => Math.round(bar_13.data.data_a.value * Math.PI * 2)),
    length: computed(
      () => Math.round((bar_13.singleLength * bar_13.num.value) / 10) / 100
    ),
  });

  let bar_14 = reactive({
    No: "14",
    diameter: { name: "14_diameter", value: 16 },
    space: { name: "14_space", value: 150, status: false },
    num: { name: "14_num", value: 110, status: true },
    data: {
      data_a: {
        name: "data_14_a",
        title: "半径R1",
        value:
          Br_out.value +
          100 +
          Math.floor(
            (bar_8.data.data_b.value / 2 -
              (Br_out.value - Br_in.value) / 2 -
              100) /
            150
          ) *
          150,
        status: true,
      },
      data_b: {
        name: "data_14_b",
        title: "半径R2",
        value: Br_out.value + 100,
        status: true,
      },
      data_c: {
        name: "data_14_c",
        title: "半径R3",
        value: Br_in.value - 100,
        status: true,
      },
      data_d: {
        name: "data_14_d",
        title: "半径R4",
        value:
          Br_in.value -
          100 -
          Math.floor(
            (bar_8.data.data_b.value / 2 -
              (Br_out.value - Br_in.value) / 2 -
              100) /
            150
          ) *
          150,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/04&14.png",
    singleLength: computed(() =>
      [
        Math.round(bar_14.data.data_a.value * Math.PI * 2),
        Math.round(bar_14.data.data_b.value * Math.PI * 2),
        Math.round(bar_14.data.data_c.value * Math.PI * 2),
        Math.round(bar_14.data.data_d.value * Math.PI * 2),
      ]),
    length: computed(() => {
      return (
        Math.round(
          (((sum(bar_14.singleLength) / 2) /
            10) *
            bar_14.num.value) /
          2) / 100
      );
    }),
  });

  let bar_15 = reactive({
    No: "15",
    diameter: { name: "15_diameter", value: 12 },
    space: { name: "15_space", value: "—", status: true },
    data: {
      data_set: {
        name: "data_15_set",
        title: "是否设置",
        value: 1,
        status: false,
      },
      data_a: {
        name: "data_15_a",
        title: "参数a",
        value: 400,
        status: false,
      },
      data_b: {
        name: "data_15_b",
        title: "参数b",
        value: 3400,
        status: false,
      },
    },
    num: {
      name: "15_num",
      value: computed(() => {
        if (bar_15.data.data_set.value == 1) {
          return Bnum_in.value * (bar_1a.data.data_n.value + 1);
        } else {
          return 0;
        }

      }),
      status: true,
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/01.png",
    singleLength: computed(() => {
      if (bar_15.data.data_a.value <= 0) {
        return 0;
      } else {
        return (bar_15.data.data_a.value +
          bar_15.data.data_b.value)
      }
    }),
    length: computed(
      () => {
        if (bar_15.data.data_a.value <= 0) {
          return 0;
        } else {
          return Math.round(
            ((bar_15.data.data_a.value +
              bar_15.data.data_b.value) *
              bar_15.num.value) /
            10) / 100
        }

      }
    ),
  });

  let bar_15a = reactive({
    No: "15a",
    diameter: { name: "15a_diameter", value: 12 },
    space: { name: "15a_space", value: "—", status: true },
    data: {
      data_set: {
        name: "data_15_set",
        title: "是否设置",
        value: 1,
        status: false,
      },
      data_a: {
        name: "data_15a_a",
        title: "参数a",
        value: 400,
        status: false,
      },
      data_b: {
        name: "data_15a_b",
        title: "参数b",
        value: 3540,
        status: false,
      },
    },
    num: {
      name: "15a_num",
      value: computed(() => {
        if (bar_15a.data.data_set.value == 1) {
          return Bnum_in.value * (bar_2a.data.data_n.value + 1);
        } else {
          return 0;
        }
      }),
      status: true,
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/15.png",
    singleLength: computed(() => {
      if (bar_15a.data.data_a.value <= 0) {
        return 0;
      } else {
        return (bar_15a.data.data_a.value +
          bar_15a.data.data_b.value)
      }
    }),
    length: computed(
      () => {
        if (bar_15a.data.data_a.value <= 0) {
          return 0;
        } else {
          return Math.round(
            ((bar_15a.data.data_a.value +
              bar_15a.data.data_b.value) *
              bar_15a.num.value) /
            10) / 100
        }

      }
    ),
  });


  let bar_16 = reactive({
    No: "16",
    diameter: { name: "16_diameter", value: 20 },
    space: { name: "16_space", value: "—", status: true },
    num: { name: "16_num", value: 30, status: false },
    data: {
      data_r: {
        name: "data_16_r",
        title: "定位半径",
        value: 5400,
        status: false,
      },
      data_set: {
        name: "data_16_set",
        title: "架立方向",
        value: 1,
        status: false,
      },
      data_a: {
        name: "data_16_a",
        title: "参数a",
        value: 300,
        status: false,
      },
      data_b: {
        name: "data_16_b",
        title: "参数b",
        value: 1969,
        status: true,
      },
      data_c: {
        name: "data_16_c",
        title: "参数c",
        value: 400,
        status: false,
      },
      data_d: {
        name: "data_16_d",
        title: "参数d",
        value: 1969,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/16~18.png",
    singleLength: computed(() => bar_16.data.data_a.value * 2 +
      bar_16.data.data_b.value +
      bar_16.data.data_c.value +
      bar_16.data.data_d.value),
    length: computed(
      () =>
        Math.round(
          ((bar_16.singleLength) *
            bar_16.num.value) /
          10) / 100
    ),
  });

  let bar_17 = reactive({
    No: "17",
    diameter: { name: "17_diameter", value: 20 },
    space: { name: "17_space", value: "—", status: true },
    num: { name: "17_num", value: 30, status: false },
    data: {
      data_r: {
        name: "data_17_r",
        title: "定位半径",
        value: 7400,
        status: false,
      },
      // data_set: {
      //   name: "data_17_set",
      //   title: "架立方向",
      //   value: "同16",
      //   status: true,
      // },
      data_a: {
        name: "data_17_a",
        title: "参数a",
        value: 300,
        status: false,
      },
      data_b: {
        name: "data_17_b",
        title: "参数b",
        value: 1393,
        status: true,
      },
      data_c: {
        name: "data_17_c",
        title: "参数c",
        value: 400,
        status: false,
      },
      data_d: {
        name: "data_17_d",
        title: "参数d",
        value: 1393,
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/16~18.png",
    singleLength: computed(() => bar_17.data.data_a.value * 2 +
      bar_17.data.data_b.value +
      bar_17.data.data_c.value +
      bar_17.data.data_d.value),
    length: computed(
      () =>
        Math.round(
          ((bar_17.singleLength) *
            bar_17.num.value) /
          10) / 100
    ),
  });

  let bar_18 = reactive({
    No: "18",
    diameter: { name: "18_diameter", value: 20 },
    space: { name: "18_space", value: "—", status: true },
    num: { name: "18_num", value: 0, status: true },
    data: {
      data_set: {
        name: "data_1b_set",
        title: "是否设置",
        value: 0,
        status: false,
      },
      data_r: {
        name: "data_18_r",
        title: "定位半径",
        value: "—",
        status: true,
      },

      data_a: {
        name: "data_18_a",
        title: "参数a",
        value: "—",
        status: true,
      },
      data_b: {
        name: "data_18_b",
        title: "参数b",
        value: "—",
        status: true,
      },
      data_c: {
        name: "data_18_c",
        title: "参数c",
        value: "—",
        status: true,
      },
      data_d: {
        name: "data_18_d",
        title: "参数d",
        value: "—",
        status: true,
      },
    },
    dataShow: false,
    iconClass: "iconfont icon-chevron_down",
    imgSRC: "/imgs/16~18.png",
    singleLength: computed(() => {
      if (bar_18.data.data_set.value == 1) {
        return bar_18.data.data_a.value * 2 +
          bar_18.data.data_b.value +
          bar_18.data.data_c.value +
          bar_18.data.data_d.value;
      } else {
        return 0;
      }
    }),
    length: computed(() => {
      if (bar_18.data.data_set.value == 1) {
        return (
          Math.round(
            ((bar_18.singleLength) *
              bar_18.num.value) /
            10) / 100
        );
      } else {
        return 0;
      }
    }),
  });

  let params_bar = [
    bar_1,
    bar_1a,
    bar_1b,
    bar_1c,
    bar_2,
    bar_2a,
    bar_3,
    bar_4,
    bar_4a,
    bar_4b,
    bar_5,
    bar_5a,
    bar_5b,
    bar_6,
    bar_7,
    bar_7a,
    bar_8,
    bar_9,
    bar_10,
    bar_11,
    bar_12,
    bar_13,
    bar_14,
    bar_15,
    bar_15a,
    bar_16,
    bar_17,
    bar_18,
  ];



  // 6定义混凝土参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let body = reactive({
    name: "body",
    title: "混凝土强度: 基础",
    value: 40,
  });
  let layer = reactive({
    name: "layer",
    title: "垫层",
    value: 15,
  });

  let concrete = [body, layer];



  // 7定义荷载参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let params_force = reactive({
    normal: {
      name: "正常运行工况",
      fr: { name: "nor_fr", value: 0, status: false },
      mr: { name: "nor_mr", value: 0, status: false },
      fz: { name: "nor_fz", value: 0, status: false },
      mz: { name: "nor_mz", value: 0, status: false },
    },
    extreme: {
      name: "极端条件工况",
      fr: { name: "extre_fr", value: 0, status: false },
      mr: { name: "extre_mr", value: 0, status: false },
      fz: { name: "extre_fz", value: 0, status: false },
      mz: { name: "extre_mz", value: 0, status: false },
    },
    small_eq: {
      name: "多遇地震作用",
      fr: { name: "s_eq_fr", value: 0, status: true, isActived: false },
      mr: { name: "s_eq_mr", value: 0, status: true, isActived: false },
      fz: { name: "s_eq_fz", value: 0, status: true, isActived: false },
      mz: { name: "s_eq_mz", value: 0, status: true, isActived: false },
    },
    large_eq: {
      name: "罕遇地震作用",
      fr: { name: "l_eq_fr", value: 0, status: true, isActived: false },
      mr: { name: "l_eq_mr", value: 0, status: true, isActived: false },
      fz: { name: "l_eq_fz", value: 0, status: true, isActived: false },
      mz: { name: "l_eq_mz", value: 0, status: true, isActived: false },
    },
    fatigue_upper: {
      name: "疲劳荷载工况(上限)",
      fr: { name: "f_upper_fr", value: 0, status: true, isActived: false },
      mr: { name: "f_upper_mr", value: 0, status: true, isActived: false },
      fz: { name: "f_upper_fz", value: 0, status: true, isActived: false },
      mz: { name: "f_upper_mz", value: 0, status: true, isActived: false },
    },
    fatigue_lower: {
      name: "疲劳荷载工况(下限)",
      fr: { name: "f_lower_fr", value: 0, status: true, isActived: false },
      mr: { name: "f_lower_mr", value: 0, status: true, isActived: false },
      fz: { name: "f_lower_fz", value: 0, status: true, isActived: false },
      mz: { name: "f_lower_mz", value: 0, status: true, isActived: false },
    },
  });

  // 8定义岩土参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let soil_1 = reactive({
    index: { name: "index", value: 0 },
    name: { name: "name", value: "soil_1" },
    thk: { name: "thk", value: 10 },
    density: { name: "density", value: 20 },
    modulus: { name: "modulus", value: 12 },
    dynamic_modulus: { name: "dynamic_modulus", value: 60 },
    e: { name: "e", value: 0.75 },  //空隙比
    v: { name: "v", value: 0 },   //泊松比
    speed: { name: "speed", value: 200 },  //剪切波速
    fak: { name: "fak", value: 300 },
    factor_width: { name: "factor_width", value: 1 },  //宽度系数
    factor_depth: { name: "factor_depth", value: 1 },  //深度系数
    factor_seism: { name: "factor_seism", value: 1 }  //地基承载力地震调整系数
  })
  let soil_2 = reactive({
    index: { name: "index", value: 1 },
    name: { name: "name", value: "soil_2" },
    thk: { name: "thk", value: 15 },
    density: { name: "density", value: 20 },
    modulus: { name: "modulus", value: 12 },
    dynamic_modulus: { name: "dynamic_modulus", value: 70 },
    e: { name: "e", value: 0.75 },  //空隙比
    v: { name: "v", value: 0 },   //泊松比
    speed: { name: "speed", value: 200 },  //剪切波速
    fak: { name: "fak", value: 300 },
    factor_width: { name: "factor_width", value: 1 },  //宽度系数
    factor_depth: { name: "factor_depth", value: 1 },  //深度系数
    factor_seism: { name: "factor_seism", value: 1 }  //地基承载力地震调整系数
  })

  let params_soil = [
    soil_1,
    soil_2
  ]

  let params_soil_extra = reactive({
    water_depth: { name: "water_depth_high", title: "水位埋深(m)", value: 0 },
    // water_depth: { name: "water_depth", title: "低水位埋深(m)", value: 10 },
    backfill_density: { name: "backfill_density", title: "覆土容重(kN/m3)", value: 17 },
    rotational_stiffness: { name: "rotational_stiffness", title: "要求旋转动态刚度(10^11Nm/rad)", value: 1.5 },
    horizontal_stiffness: { name: "horizontal_stiffness", title: "要求水平动态刚度(10^9N/m)", value: 1 },
    friction_coeff: { name: "friction_coeff", title: "基底摩擦系数", value: 0.35 },
    allowed_deform: { name: "allowed_deform", title: "允许沉降值(mm)", value: 100, imgShow: false },
    allowed_incline: { name: "allowed_incline", title: "允许倾斜值", value: 0.004, imgShow: false },
  })
  // 9定义其他参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let total_material = reactive({
    'rebar': 0,
    'C15': computed(() => {
      let hole_Depth = holeDepth.value * 1000; // 中心凹槽深度;
      let thick_groove = holeCushionThick.value * 1000; // 中心凹槽厚度
      let cushion_thick = cushionThick.value * 1000; // 缝隙厚度
      //外圈尺寸
      let r1 = holeRadius.value * 1000; // 中心凹槽外扩;
      let r2 = r1 + (thick_groove + hole_Depth - cushion_thick);
      // 内圈尺寸
      let r3 = r1 - thick_groove * Math.tan((22.5 * Math.PI) / 180);
      let r4 = r3 + (hole_Depth - 100);
      let r5 = r3 + hole_Depth;
      let C15 =
        Math.PI * Math.pow(R.value * 1000 + 100, 2) * cushion_thick -
        (100 / 3) *
        (Math.PI * Math.pow(r5, 2) +
          Math.PI * Math.pow(r4, 2) +
          Math.PI * r5 * r4) +
        (((hole_Depth + thick_groove - cushion_thick) / 3) *
          (Math.PI * Math.pow(r1, 2) +
            Math.PI * Math.pow(r2, 2) +
            Math.PI * r1 * r2) -
          ((hole_Depth - cushion_thick) / 3) *
          (Math.PI * Math.pow(r3, 2) +
            Math.PI * Math.pow(r4, 2) +
            Math.PI * r3 * r4));
      return (C15 / 1000 / 1000 / 1000).toFixed(2);
    }),

    'C40': computed(() => {
      let hole_Depth = holeDepth.value * 1000; // 中心凹槽深度;
      let thick_groove = holeCushionThick.value * 1000; // 中心凹槽厚度
      //外圈尺寸
      let r1 = holeRadius.value * 1000; // 中心凹槽外扩;
      // 内圈尺寸
      let r3 = r1 - thick_groove * Math.tan((22.5 * Math.PI) / 180);
      let r5 = r3 + hole_Depth;
      let C40 =
        (hole_Depth / 3) *
        (Math.PI * Math.pow(r3, 2) +
          Math.PI * Math.pow(r5, 2) +
          Math.PI * r3 * r5) +
        Math.PI * Math.pow(R.value * 1000, 2) * H1.value * 1000 +
        ((H2.value * 1000) / 3) *
        (Math.PI * Math.pow(R.value * 1000, 2) +
          Math.PI * Math.pow(R1.value * 1000, 2) +
          Math.PI * R.value * 1000 * R1.value * 1000) +
        H3.value * 1000 * Math.PI * Math.pow(R2.value * 1000, 2);

      return (C40 / 1000 / 1000 / 1000).toFixed(2);
    }),

    'dig': computed(() => {
      let h_dig = H1.value + H2.value + H3.value + cushionThick.value - backFillRatio.slopY / 1000;
      let r_bottom = R.value + 0.1 + extralWidth.value;
      let r_top = r_bottom + Ratio.value * (h_dig);
      let v1 = (h_dig) / 3 *
        (Math.PI * Math.pow(r_bottom, 2) + Math.PI * Math.pow(r_top, 2) + Math.PI * r_bottom * r_top)
      let h_hole = holeCushionThick.value + holeDepth.value - cushionThick.value;
      let v2 = (h_hole) / 3 *
        (Math.PI * Math.pow(holeRadius.value, 2) + Math.PI * Math.pow(holeRadius.value + h_hole, 2) + Math.PI * holeRadius.value * (holeRadius.value + h_hole))
      return (v1 + v2).toFixed(2);
    }),

    'fillback': computed(() => {
      let h_slop = backFillRatio.slopY / 1000 - (H1.value + H2.value + H3.value - Hd.value);
      let v_slop = (h_slop) / 3 *
        (Math.PI * Math.pow(R2.value, 2) +
          Math.PI * Math.pow(backFillRatio.slopX / 1000, 2) +
          Math.PI * R2.value * backFillRatio.slopX / 1000) - h_slop * Math.PI * Math.pow(R2.value, 2);
      return (total_material.dig - total_material.C15 -
        (total_material.C40 - backFillRatio.slopY / 1000 * Math.PI * Math.pow(R2.value, 2)) +
        v_slop).toFixed(2)
    }),
  });

  // 10定义计算参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let importance = reactive({
    name: "importance",
    title: "结构重要性系数",
    value: 1.1,
  })
  let gama = reactive({
    g1: {
      name: "g1",
      title: "恒载(不利)",
      value: 1.3,
    },
    g2: {
      name: "g2",
      title: "恒载(有利)",
      value: 1.0,
    },
    q: {
      name: "g",
      title: "活载",
      value: 1.5,
    },
    eh: {
      name: "eh",
      title: "水平地震",
      value: 1.4,
    },
    ev: {
      name: "ev",
      title: "竖向地震",
      value: 0.5,
    },
  })
  let params_calculation = [importance, gama]

  // 11定义配筋参数>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let bottom_radial_bar_strength = reactive({
    No: '1',
    name: "bottom_radial_strength",
    title: "底部径向筋强度",
    value: 360,
    type: "strength"
  });
  let bottom_radial_bar_diameter = reactive({
    No: '2',
    name: "bottom_radial_diameter",
    title: "底部径向筋最小直径",
    value: 25,
    type: "diameter"
  });
  let bottom_tangential_bar_strength = reactive({
    No: '3',
    name: "bottom_tangential_strength",
    title: "底部环向筋强度",
    value: 360,
    type: "strength"
  });
  let bottom_tangential_bar_diameter = reactive({
    No: '4',
    name: "bottom_tangential_diameter",
    title: "底部环向筋直径",
    value: 25,
    type: "diameter"
  });
  let top_radial_bar_strength = reactive({
    No: '5',
    name: "top_radial_strength",
    title: "顶部径向筋强度",
    value: 360,
    type: "strength"
  });
  let top_radial_bar_diameter = reactive({
    No: '6',
    name: "top_radial_diameter",
    title: "顶部径向筋最小直径",
    value: 25,
    type: "diameter"
  });
  let top_tangential_bar_strength = reactive({
    No: '7',
    name: "top_tangential_strength",
    title: "顶部环向筋强度",
    value: 360,
    type: "strength"
  });
  let top_tangential_bar_diameter = reactive({
    No: '8',
    name: "top_tangential_diameter",
    title: "顶部环向筋直径",
    value: 25,
    type: "diameter"
  });
  let tangential_num = reactive({
    No: '9',
    name: "tangential_num",
    title: "环向筋分段数",
    value: 3,
    type: "num"
  });
  let tangential_r1 = reactive({
    No: '10',
    name: "tangential_r1",
    title: "第一段内径(m)",
    value: computed(() => R2.value),
    status: true,
    type: "value"
  });
  let tangential_r2 = reactive({
    No: '11',
    name: "tangential_r2",
    title: "第二段内径(m)",
    value: Math.round((R2.value + (R.value - R2.value) / 3) * 100) / 100,
    status: computed(() => {
      return tangential_num.value < 2;
    }),
    type: "value"
  });
  let tangential_r3 = reactive({
    No: '12',
    name: "tangential_r3",
    title: "第三段内径(m)",
    value: Math.round((R2.value + (R.value - R2.value) * 2 / 3) * 100) / 100,
    status: computed(() => {
      return tangential_num.value < 3;
    }),
    type: "value"
  });
  let local_bar_strength = reactive({
    No: '13',
    name: "local_bar_strength",
    title: "锚板局压钢筋强度",
    value: 360,
    type: "strength"
  });

  let design_bar = [
    bottom_radial_bar_strength,
    bottom_radial_bar_diameter,
    bottom_tangential_bar_strength,
    bottom_tangential_bar_diameter,
    top_radial_bar_strength,
    top_radial_bar_diameter,
    top_tangential_bar_strength,
    top_tangential_bar_diameter,
    tangential_num,
    tangential_r1,
    tangential_r2,
    tangential_r3,
    local_bar_strength,
  ];


  return {
    params_basic,
    params_geometry,
    params_bolt,
    params_embed,
    params_bar,
    cover,
    concrete,
    params_force,
    params_soil,
    params_soil_extra,
    total_material,
    params_calculation,
    design_bar,
  };
}
